import { resolveComponent as _resolveComponent, openBlock as _openBlock, createBlock as _createBlock, createCommentVNode as _createCommentVNode, createVNode as _createVNode, Fragment as _Fragment, toDisplayString as _toDisplayString, renderList as _renderList, withCtx as _withCtx } from "vue"

const _hoisted_1 = {
  key: 0,
  class: "flex flex--width flex--v flex--valign-c flex--gap-20"
}
const _hoisted_2 = { class: "text text--size-24 text--primary-b text--semi-bold text--center" }
const _hoisted_3 = { class: "text text--size-20 text--accent-gray-b text--center" }

export function render(_ctx: any,_cache: any,$props: any,$setup: any,$data: any,$options: any) {
  const _component_GenericButton = _resolveComponent("GenericButton")
  const _component_CompanyCard = _resolveComponent("CompanyCard")
  const _component_MainPage = _resolveComponent("MainPage")

  return (_openBlock(), _createBlock(_component_MainPage, {
    "bread-crumb-titles": _ctx.breadCrumbTitles,
    "title-id": 'startOfCompanyList',
    gap: true
  }, {
    default: _withCtx(() => [
      (_ctx.detailViewCompany)
        ? (_openBlock(), _createBlock(_Fragment, { key: 0 }, [
            (_ctx.detailViewCompany)
              ? (_openBlock(), _createBlock(_component_GenericButton, {
                  key: 0,
                  title: _ctx.$trans('company.button_back_to_results'),
                  identifier: 'arrow_left',
                  "omit-icon-when-s-m": false,
                  onClick: _ctx.onClickCloseDetails
                }, null, 8, ["title", "onClick"]))
              : _createCommentVNode("", true),
            _createVNode(_component_CompanyCard, {
              company: _ctx.detailViewCompany,
              "qualification-groups": _ctx.qualificationGroups,
              "qualification-input": _ctx.qualificationInput,
              "more-info": true,
              onClickDetails: _cache[1] || (_cache[1] = ($event: any) => (_ctx.onClickDetails(_ctx.detailViewCompany.id)))
            }, null, 8, ["company", "qualification-groups", "qualification-input"]),
            (_ctx.detailViewCompany)
              ? (_openBlock(), _createBlock(_component_GenericButton, {
                  key: 1,
                  title: _ctx.$trans('company.button_back_to_results'),
                  identifier: 'arrow_left',
                  "omit-icon-when-s-m": false,
                  onClick: _ctx.onClickCloseDetails
                }, null, 8, ["title", "onClick"]))
              : _createCommentVNode("", true)
          ], 64))
        : (_openBlock(), _createBlock(_Fragment, { key: 1 }, [
            _createVNode(_component_GenericButton, {
              title: _ctx.$trans('company.button_back_to_search'),
              identifier: 'arrow_left',
              "omit-icon-when-s-m": false,
              onClick: _ctx.onClickBackToSearch
            }, null, 8, ["title", "onClick"]),
            (_ctx.noCompanies)
              ? (_openBlock(), _createBlock("div", _hoisted_1, [
                  _createVNode("span", _hoisted_2, _toDisplayString(_ctx.$trans("search.no-companies-headline")), 1),
                  _createVNode("span", _hoisted_3, _toDisplayString(_ctx.$trans("search.no-companies-subheadline")), 1)
                ]))
              : (_openBlock(true), _createBlock(_Fragment, { key: 1 }, _renderList(_ctx.companies, (company) => {
                  return (_openBlock(), _createBlock(_component_CompanyCard, {
                    key: company.id,
                    "qualification-groups": _ctx.qualificationGroups,
                    "qualification-input": _ctx.qualificationInput,
                    company: company,
                    "more-info": !!_ctx.detailViewCompany,
                    onClickDetails: ($event: any) => (_ctx.onClickDetails(company.id))
                  }, null, 8, ["qualification-groups", "qualification-input", "company", "more-info", "onClickDetails"]))
                }), 128))
          ], 64))
    ]),
    _: 1
  }, 8, ["bread-crumb-titles"]))
}